import * as React from "react";
import { FeedItemCommentLike } from "../../../server/feed/buildfeed";
import { FeedElementContainer } from "../DesignSystem/formatting/FeedComponents";
import { LinkToUser } from "../DesignSystem/LinkToUser";
import { RLink } from "../DesignSystem/RLink";
import { DateWithTooltip } from "../DesignSystem/DateWithTooltip";

export const FeedElementCommentLike = ({
  item,
}: {
  item: FeedItemCommentLike;
}) => {
  return (
    <FeedElementContainer
      href={`/entry/${item.entry_id}`}
      avatars={[
        { username: item.liking_username, avatar_url: item.avatar_url },
      ]}
      icon={"comment-heart"}
      title={
        <>
          <LinkToUser linkUser={{ username: item.liking_username }} />
          <span className="text-slate-500 dark:text-slate-400"> liked your post on </span>
          <RLink white to={"/entry/" + item.entry_id}>{item.title}</RLink>
        </>
      }
      subtitle={<DateWithTooltip date={new Date(item.created)} />}
    ></FeedElementContainer>
  );
};
